module.exports = __webpack_public_path__ + "img/YouTube.a076cbd1.png";